import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/OrganizationQuotasResource.ts
var n = class n extends t {
	static {
		this.quotasBaseUrl = `/api/private/organizations/${e.orgPlaceholder}/quotas`;
	}
	static {
		this.entitlementsBaseUrl = `/api/private/organizations/${e.orgPlaceholder}/quotas/entitlements`;
	}
	listQuotas() {
		return this.api.get(n.quotasBaseUrl);
	}
	listQuotaSections() {
		return this.api.get(`${n.quotasBaseUrl}/sections`);
	}
	getQuota(e, t) {
		return this.api.get(`${n.quotasBaseUrl}/${e}/${t}`);
	}
	async getQuotaHistory(e, t, r) {
		return this.api.get(this.buildPath(`${n.quotasBaseUrl}/${e}/${t}/history`, r));
	}
	async exportQuotaHistory(e, t, r) {
		return this.api.get(this.buildPath(`${n.quotasBaseUrl}/${e}/${t}/history/export`, r), { responseBodyFormat: "text" });
	}
	listEntitlementQuotas() {
		return this.api.get(n.entitlementsBaseUrl);
	}
	getEntitlementQuota(e) {
		return this.api.get(`${n.entitlementsBaseUrl}/${e}`);
	}
	async getEntitlementProducts(e) {
		return this.api.get(this.buildPath(`${n.entitlementsBaseUrl}/${e}/related-products`));
	}
	async getEntitlementHistory(e, t) {
		return this.api.get(this.buildPath(`${n.entitlementsBaseUrl}/${e}/history`, t));
	}
	async getEntitlementConsumptionHistory(e, t) {
		return this.api.get(this.buildPath(`${n.entitlementsBaseUrl}/${e}/consumption/history`, t));
	}
	async exportEntitlementHistory(e, t) {
		return this.api.get(this.buildPath(`${n.entitlementsBaseUrl}/${e}/history/export`, t), { responseBodyFormat: "text" });
	}
	async exportEntitlementConsumptionHistory(e, t) {
		return this.api.get(this.buildPath(`${n.entitlementsBaseUrl}/${e}/consumption/history/export`, t), { responseBodyFormat: "text" });
	}
};
export { n as OrganizationQuotasResource };

//# sourceMappingURL=OrganizationQuotasResource.js.map